import sanityClient from "../client.js"
import React, { useEffect, useRef, useState, useMemo } from 'react'
import imageUrlBuilder from '@sanity/image-url'
import BlockContent from '@sanity/block-content-to-react'

import '../style/gallery.sass'
import '../style/spinner.sass'
import '../style/index.sass'

const builder = imageUrlBuilder(sanityClient)
function urlFor(source) {
    return builder.image(source)
}

export default function Piece({ picture, shotFinished }) {
    const [pic] = useState(picture)
    const [figure, setFigure] = useState(<>Loading</>)

    const ref = useRef(null)
    const isInViewport = useIsInViewport(ref)

    useEffect(() => {
        figureRender()
    }, [isInViewport, pic])

    const figureRender = () => {
        if (isInViewport && pic) {
            setFigure(
                <>
                    <img src={urlFor(pic.mainImage).url()} alt={pic.mainImage.alt} />
                    <div className="text">
                        <h3 className="title">{pic.title}</h3>
                        <p className="completedAt"><strong>{shotFinished}</strong> {new Date(pic.publishedAt).toLocaleDateString()}</p>
                        <div className="textBlock">
                            <BlockContent blocks={pic.body} projectId="0bpi20mw" dataset="production" />
                        </div>
                    </div>
                </>
            )
        }
    }

    return (
        <article ref={ref}>
            {figure}
        </article>
    )
}

function useIsInViewport(ref) {
    const [isIntersecting, setIsIntersecting] = useState(false)
    const observer = useMemo(
        () =>
            new IntersectionObserver(([entry]) =>
                setIsIntersecting(entry.isIntersecting),
            ),
        [],
    )
    // console.log(observer)
    useEffect(() => {
        observer.observe(ref.current)
        // console.log(ref.current)
        return () => {
            observer.disconnect()
        }
    }, [ref, observer])

    return isIntersecting
}
